export enum FieldTypeCode {
    TITLE='TITLE',
    TEXT='TEXT',
    TABLE_COMPLEX='TABLE_COMPLEX',
    NUMBER='NUMBER',
    TEXTAREA='TEXTAREA',
    DATE='DATE',
    DATETIME='DATETIME',
    SELECTLIST_SINGLE='SELECTLIST_SINGLE',
    MULTIPLE_CHOICE='MULTIPLE_CHOICE',
    RADIO_BUTTON='RADIO_BUTTON',
    LABEL='LABEL',
    CHECK_BOX='CHECK_BOX',
    NUMBER_CURRENCY='NUMBER_CURRENCY',
    TEXT_CHECK_BOX='TEXT_CHECK_BOX',
    DATE_CHECK_BOX='DATE_CHECK_BOX',
    SPACE='SPACE',
    UPLOAD_FILE='UPLOAD_FILE'
}

export enum TITLE{
    ADD_DATA='THÊM MỚI DỮ LIỆU',
    UPDATE_DATA='CẬP NHẬT DỮ LIỆU'
}
